module.exports = {
      id: "point-arrow-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#point-arrow",
      toString: function () {
        return this.url;
      }
    }